import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { Textbox, Textarea } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "./constants";

class CenterDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      _id: "",
      name: "",
      nameMal: "",
      desc: "",
      descMal: "",
      location: "",
      locationMal: "",
      regno: "",
      address: "",
      addressMal: "",
      phone: ""
    };
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/center/edit"
      )
      .then(response => {
        this.setState({
          _id: response.data._id,
          name: response.data.name,
          desc: response.data.desc,
          location: response.data.location,
          regno: response.data.regno,
          address: response.data.address,
          phone: response.data.phone,
          nameMal: response.data.nameMal,
          descMal: response.data.descMal,
          locationMal: response.data.locationMal,
          addressMal: response.data.addressMal,
          medExpiryDays: response.data.medExpiryDays,
          medThresholdCount: response.data.medThresholdCount
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <h5 align="center">Center Details</h5>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2"></div>
              <div className="col col-md-4">
                <i>English</i>
              </div>
              <div className="col col-md-4">
                <i>മലയാളം</i>
              </div>
            </div>

            <div className="row p-1 border">
              <div className="col col-md-2">Name</div>
              <div className="col col-md-4">
                <Textbox
                  id="name"
                  value={this.state.name}
                  placeholder="Enter Name"
                  onChange={(name, e) => {
                    this.setState({ name });
                  }}
                />
              </div>
              <div className="col col-md-4">
                <Textbox
                  id="nameMal"
                  value={this.state.nameMal}
                  placeholder="Enter Malayalam Name"
                  onChange={(nameMal, e) => {
                    this.setState({ nameMal });
                  }}
                />
              </div>
            </div>

            <div className="row p-1 border">
              <div className="col col-md-2">Description</div>
              <div className="col col-md-4">
                <Textbox
                  id="desc"
                  value={this.state.desc}
                  placeholder="Enter Description"
                  onChange={(desc, e) => {
                    this.setState({ desc });
                  }}
                />
              </div>
              <div className="col col-md-4">
                <Textbox
                  id="descMal"
                  value={this.state.descMal}
                  placeholder="Enter Malayalam Description"
                  onChange={(descMal, e) => {
                    this.setState({ descMal });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Location</div>
              <div className="col col-md-4">
                <Textbox
                  id="loc"
                  value={this.state.location}
                  placeholder="Enter Location"
                  onChange={(location, e) => {
                    this.setState({ location });
                  }}
                />
              </div>
              <div className="col col-md-4">
                <Textbox
                  id="locMal"
                  value={this.state.locationMal}
                  placeholder="Enter Malayalam Location"
                  onChange={(locationMal, e) => {
                    this.setState({ locationMal });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Reg #</div>
              <div className="col col-md-4">
                <Textbox
                  id="regno"
                  value={this.state.regno}
                  placeholder="Enter Reg #"
                  onChange={(regno, e) => {
                    this.setState({ regno });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Address</div>
              <div className="col col-md-4">
                <Textarea
                  value={this.state.address}
                  rows="5"
                  placeholder="Enter Address"
                  onChange={(address, e) => {
                    this.setState({ address });
                  }}
                />
              </div>
              <div className="col col-md-4">
                <Textarea
                  value={this.state.addressMal}
                  rows="5"
                  placeholder="Enter Malayalam Address"
                  onChange={(addressMal, e) => {
                    this.setState({ addressMal });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Phone #</div>
              <div className="col col-md-4">
                <Textbox
                  id="phone"
                  value={this.state.phone}
                  placeholder="Enter Phone #"
                  onChange={(phone, e) => {
                    this.setState({ phone });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Medical Report Expired Days</div>
              <div className="col col-md-4">
                <Textbox
                  id="days"
                  value={this.state.medExpiryDays}
                  onChange={(medExpiryDays, e) => {
                    this.setState({ medExpiryDays });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">
                Medical Report Threshold Quantity
              </div>
              <div className="col col-md-4">
                <Textbox
                  id="count"
                  value={this.state.medThresholdCount}
                  onChange={(medThresholdCount, e) => {
                    this.setState({ medThresholdCount });
                  }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  onSaveClick = async e => {
    e.preventDefault();

    const obj = {
      name: this.state.name,
      location: this.state.location,
      phone: this.state.phone,
      desc: this.state.desc,
      regno: this.state.regno,
      address: this.state.address,
      nameMal: this.state.nameMal,
      locationMal: this.state.locationMal,
      descMal: this.state.descMal,
      addressMal: this.state.addressMal,
      medExpiryDays: this.state.medExpiryDays,
      medThresholdCount: this.state.medThresholdCount
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          "/center/update/" +
          this.state._id,
        obj
      )
      .then(res => {
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Center Details Updated !!!"
        });
      });
  };
}

export default CenterDetails;
